<div class="page-topbar sidebar_shift">
  <!-- START LOGO AREA -->
  <div class="logo-area">
  </div>
  <!-- END LOGO AREA -->
</div>
<!-- START CONTAINER -->
<div class="page-container row-fluid container-fluid">
  <section id="main-content" class="sidebar_shift">
    <section class="wrapper main-wrapper row">
      <table class="table table-condensed">
        @for(source of User.Sources; track source.Id) {
        <tr class="row">
          <td class="col-md-2 offset-md-3">
            <label>{{source.SourceCode}}</label>
          </td>
          <td class="col-md-4">{{source.SourceName}}</td>
          <td class="col-md-1">
            <input type="button" value="select" (click)="selectSource(source)" class="btn btn-success form-control" />
          </td>
        </tr>
        }
      </table>
    </section>
  </section>
</div>

